import { Typography } from "@lyfegen-platform/react-common";
import { Avatar, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import LyfeTooltip from "./LyfeTooltip";

interface StyleProps {
	style?: React.CSSProperties;
	className?: string;
}

interface LyfeAgreementTagProps {
	title: string;
	currentUser?: boolean;
	tooltipProps?: StyleProps & { open?: boolean };
	avatarProps?: StyleProps;
	hideTooltip?: boolean;
	avatarStyle?: React.CSSProperties;
	height?: number;
}

const LyfeAgreementTag: React.FC<LyfeAgreementTagProps> = ({
	title,
	currentUser,
	tooltipProps,
	avatarProps,
	hideTooltip,
	avatarStyle,
	height,
}) => {
	const { palette, spacing } = useTheme();
	const { t } = useTranslation();
	const getAlphaVal = (s: any) => s.toLowerCase().charCodeAt(0) - 97 + 1;

	const getColors = () => {
		if (currentUser) return [palette.warning.dark, palette.warning.light];
		const alphaValue = getAlphaVal(title);

		if (alphaValue <= 2) return ["#a87511", "#fff4dc"];
		if (alphaValue > 2 && alphaValue <= 4) return ["#614faa", "#daddfe"];
		if (alphaValue > 4 && alphaValue <= 6) return ["#bf3e93", "#ffecf7"];
		if (alphaValue > 6 && alphaValue <= 8) return ["#007178", "#ccf6f2"];
		if (alphaValue > 8 && alphaValue <= 10) return ["#a87511", "#eee3d8"];
		if (alphaValue > 10 && alphaValue <= 12) return ["#036ed1", "#d8f3ff"];
		if (alphaValue > 12 && alphaValue <= 14) return ["#4c7057", "#e8f3d9"];
		if (alphaValue > 14 && alphaValue <= 16) return ["#7c4595", "#ede4f1"];
		if (alphaValue > 16 && alphaValue <= 18) return ["#5e6e7d", "#cddcdc"];
		if (alphaValue > 18 && alphaValue <= 22) return ["#038331", "#dfeae3"];

		return ["#007876", "#CCF6F2"];
	};

	return (
		<LyfeTooltip {...tooltipProps} disableHoverListener={hideTooltip} title={`${title}`}>
			<Avatar
				variant="rounded"
				style={{
					backgroundColor: getColors()[1],
					color: getColors()[0],
					minWidth: "max-content",
					paddingLeft: spacing(1.5),
					paddingRight: spacing(1.5),
					borderRadius: "20px",
					height: height || "24px",
					...avatarStyle,
				}}
				{...avatarProps}
			>
				<Typography style={{ fontSize: "0.9rem" }}>{t(title)}</Typography>
			</Avatar>
		</LyfeTooltip>
	);
};

export default LyfeAgreementTag;
